export const PLAY_URLS = {
  kirana: "https://play.google.com/store/apps/details?id=com.kashassist.kirana",
};
